import { hslToRgb } from "utils/hslToRgb";
import type { GenerateDistinctColors } from "./types";

export const generateDistinctColors: GenerateDistinctColors = ({ count }) => {
  if (count <= 0) return [];

  const saturation = 0.75;
  const lightness = 0.5;

  return Array.from({ length: count }, (_, index) => {
    const hue = (index * 360) / count;
    return hslToRgb({ hue, saturation, lightness });
  });
};
